import {createClient} from '@sanity/client'

const SanityClient = createClient({
  projectId: '3cv4h3wr',
  dataset: 'development',
  useCdn: true, 
  apiVersion: '2023-05-03',
})

export default SanityClient